import React from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { api } from "../lib/api";
import { Logo } from "../components/layout/Navbar";

export default function AdminLoginPage() {
  const [email, setEmail] = React.useState("kontakt@emakurer.dk");
  const [password, setPassword] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const nav = useNavigate();

  if (localStorage.getItem("ema_admin_token")) {
    const target = `/admin${window.location.search}${window.location.hash}`;
    return <Navigate to={target} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("ema_admin_token", data.token);
      toast.success("Velkommen tilbage");
      const dest = `/admin${window.location.search}${window.location.hash}`;
      nav(dest);
    } catch {
      toast.error("Forkert email eller password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-brand-bg2 flex items-center justify-center p-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-white border border-brand p-8 sm:p-10">
          <Logo />
          <div className="kicker mt-7">Admin login</div>
          <h1 className="font-display font-bold text-3xl text-brand-dark mt-2">Dashboard adgang</h1>
          <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
            <div>
              <label className="label-flat">Email</label>
              <input type="email" className="input-flat" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" required />
            </div>
            <div>
              <label className="label-flat">Password</label>
              <input type="password" className="input-flat" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required />
            </div>
            <button type="submit" className="btn-primary w-full justify-center" disabled={busy} data-testid="admin-login-submit">
              {busy ? <><Loader2 className="animate-spin" size={16} /> Logger ind...</> : <><Lock size={16} /> Log ind</>}
            </button>
            <div className="pt-2 text-center">
              <a href="/admin/forgot-password" className="text-sm text-brand-dark/70 hover:underline" data-testid="admin-forgot-link">
                Glemt password?
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
